import React, { createContext, useCallback, useMemo, useState } from 'react';
import { languages } from './translations';

const langStorageKey = 'iit-lang';

export const LanguageContext = createContext({
  lang: 'zh',
  setLang: () => {},
  t: (key) => key,
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => window.localStorage.getItem(langStorageKey) || 'zh');

  const setLang = useCallback((nextLang) => {
    const normalized = nextLang === 'en' ? 'en' : 'zh';
    setLangState(normalized);
    window.localStorage.setItem(langStorageKey, normalized);
  }, []);

  const t = useCallback((key, params) => {
    const dict = languages[lang] || languages.zh;
    let str = dict[key];
    if (str === undefined) {
      // fallback to zh then raw key
      str = (languages.zh && languages.zh[key]) || key;
    }
    if (params && typeof str === 'string') {
      str = str.replace(/\{(\w+)\}/g, (_, name) => (params[name] !== undefined ? String(params[name]) : `{${name}}`));
    }
    return str;
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
